(function($){

	$(document).ready(function(){
		pai_facts_slider();
	});

	$(window).on('resize', function(){
		pai_facts_slider();
	});


	function pai_facts_slider() {

		$('.facts-slider').each(function(index){
	
			if(!$(this).hasClass('slick-initialized') && $(window).width() < 992) {

				$prevArrow = $(this).parent().siblings('.facts-module__header').find('.facts-slider__navigation .slick-prev');
				$nextArrow = $(this).parent().siblings('.facts-module__header').find('.facts-slider__navigation .slick-next');

				update_progress($(this).siblings('.facts-slider__progress').find('.progress-bar'), 100 / $(this).find('.fact').length);

				$(this).slick({
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: false,
			        infinite: false,
					variableWidth: true,
					mobileFirst: true,
			        prevArrow: $prevArrow,
			        nextArrow: $nextArrow,

					responsive: [
						{
					      	breakpoint: 992,
					      	settings: "unslick"
					    }
					]
			    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			    	var $percent = ((nextSlide + 1) / slick.slideCount) * 100;
			    	$progress_bar = $(event.currentTarget).siblings('.facts-slider__progress').find('.progress-bar');
			    	update_progress($progress_bar, $percent);
			    }); 
			}
		});
	}

	function update_progress($progress_bar, $progress_percent) {
		console.log('Progress Bar');
		console.log($progress_bar);
		$progress_bar.css('width', $progress_percent + '%');
	}
	
	
})(jQuery);